import {Drawer} from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledDrawer = styled(props => <Drawer rootClassName={props.className} {...props} />)`
    .ant-space.ant-space-vertical {
        width: 100%;
    }

    .pre-wrap {
        white-space: pre-wrap;
    }
`;

export default StyledDrawer;
